import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ReplaceButton from './ReplaceButton';
import AppIcon from '../AppIcon';

const CompanyItem = ({ company, decorator, nameWidth = '100%', onReplaceClick }) => {
  const handleItemClick = (e) => {
    if (company.showReplaceButton) {
      e.preventDefault();
      e.stopPropagation();
      onReplaceClick(company);
    }
    return false;
  };
  return (
    <div
      key={company.value}
      className={cx('tt-suggestion', {
        disabled: company.added,
        'has-replace-btn': company.showReplaceButton,
      })}
      onClick={(e) => handleItemClick(e)}
    >
      <div className="category-item publisher-item company-item">
        <div className="d-flex align-items-center flex-grow text-truncate">
          <h4 className="d-flex align-items-center m-b-0" style={{ width: nameWidth, flexGrow: 0 }}>
            <AppIcon
              alt={company.name}
              url={company.icon_url}
              size={20}
              defaultBrokenNoStoreIcon="hicon-company"
              containerClasses="company-icon-container"
            />
            {company.bloomberg_ticker ? (
              <span className="company-ticker">{company.bloomberg_ticker}</span>
            ) : (
              <span className="company-ticker company-ticker__empty">NA</span>
            )}
            <span className="text-black text-truncate mr-xxxs publisher-item-name">
              {company.name}
            </span>
            {company.showReplaceButton && <ReplaceButton />}
          </h4>
          {decorator}
        </div>
      </div>
    </div>
  );
};

CompanyItem.propTypes = {
  company: PropTypes.object.isRequired,
  decorator: PropTypes.element,
  nameWidth: PropTypes.string,
  onReplaceClick: PropTypes.func,
};

export default CompanyItem;
